<template>
  <div
    v-if="subItem"
    class="subitem"
  >
    <div class="subitem-name">
      <span :class="['badge', itemBadge]">{{ itemBadge }}</span>
      <span class="item-name">{{ itemName }}</span>
    </div>
    <font-awesome-icon 
      :class="{ 'disabled-icon': !editable }"
      class="delete-icon text-danger"
      :icon="['fas', 'trash']" 
      @click="deleteThis" 
    />
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import { REMOVE_NAV_SUB_ITEM } from '@/store/modules/left-nav-customization/mutation-types';
const {mapState: sidebarMapState} = createNamespacedHelpers('sidebar');
const { mapMutations } = createNamespacedHelpers('leftNavCustomization');
export default {
  name: 'SubItem',
  props: {
    subItem: Object,
    editable: Boolean,
  },
  data(){
    return{
      type: null,
    };
  },
  computed: {
    ...sidebarMapState({
      entities: state => state.tablesList,
      folders: state => state.foldersList,
      modules: state => state.modulesList,
      systemModules: state => state.moduleConfiguration,
    }),
    itemBadge() {
      if (this.type === 'module') {
        return 'M';
      }
      if (this.type === 'folder') {
        return 'F';
      }
      if (this.type === 'entity') {
        return 'E';
      }
      
      return 'P'; // If none match, it's a "Path"
    },
    itemName() {
      if (!this.subItem) return 'Unknown';
      const sysModule = this.systemModules[0].children.find(x=>x.moduleGuid === this.subItem.id);//0 for system module
      if (sysModule) return sysModule.label;

      const module = this.modules[this.subItem.moduleGuid || this.subItem.id];
      if (module) {
        this.type = 'module';
        return module.label;
      }

      const folder = this.folders[this.subItem.folderGuid || this.subItem.id];
      if (folder) {
        this.type = 'folder';
        return folder.label;
      }

      const entity = this.entities[this.subItem.entityGuid || this.subItem.id];
      if (entity) {
        this.type = 'entity';
        return entity.label;
      }

      return 'Unknown';
    },
  },
  methods:{
    ...mapMutations({
      removeSubItem: REMOVE_NAV_SUB_ITEM,
    }),
    deleteThis(){
      if(!this.editable)
        return;
      this.removeSubItem(this.subItem.id);
    },
  },
};
</script>
<style scoped lang="scss">
.module {
  background-color: #cce5ff;
  color: #004085;
  padding: 8px;
  border-radius: 4px;
}

.folder {
  background-color: #d4edda;
  color: #155724;
  padding: 8px;
  border-radius: 4px;
}

.entity {
  background-color: #f8d7da;
  color: #721c24;
  padding: 8px;
  border-radius: 4px;
}

.path {
  background-color: #fdfd96;
  color: #856404;
  padding: 8px;
  border-radius: 4px;
}
.subitem{
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px; /* Reduced left padding */
  border-radius: 4px;
  margin-bottom: 10px;
  border: 1px solid #aeaeae;
  cursor:grab;
}
.badge {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 10px;
  font-weight: bold;
  color: white;
  background-color: #555;
}
.badge.M { background-color: #007bff; } /* Blue for Module */
.badge.F { background-color: #28a745; } /* Green for Folder */
.badge.E { background-color: #ffc107; } /* Yellow for Entity */
.badge.P { background-color: #6c757d; } /* Gray for Path */
.disabled-icon {
  opacity: 0.5;       // Makes it look disabled
  pointer-events: none; // Disables clicking
  cursor: not-allowed;  // Shows disabled cursor
}
.subitem-name{
  display: flex;
  align-items: center;
  gap: 10px;
}
.delete-icon{
  cursor:pointer;
}
</style>